import * as jqueryProxy from 'jquery';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotifierMessage, NotifierMessageBase, NotifierMessageType, NotifierTranslatableMessage } from './notifier.model';

import { NotifierService } from './notifier.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';

// For rollup
const jquery: JQueryStatic = (<any>jqueryProxy).default || jqueryProxy;


@Component({
  selector: 'core-notifier',
  templateUrl: './notifier.component.html',
  styleUrls: ['./notifier.component.css']
})
export class NotifierComponent implements OnInit, OnDestroy {

  notifierMessageList: Array<NotifierMessageBase>;
  private notifierSubscription: Subscription;
  private routerSubscription: Subscription;

  constructor(private notifierService: NotifierService, private router: Router, private translateService: TranslateService) {

    this.notifierMessageList = new Array<NotifierMessageBase>();
    this.notifierSubscription = this.notifierService.notifierListState.subscribe((notifierMessageList) => {
      this.notifierMessageList = notifierMessageList;
      this.setTimers();
    });

    this.routerSubscription = this.router.events.subscribe((event) => this.hideErrors());

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.hideAll();
    this.notifierSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
  }

  getMessages() {
    return this.notifierMessageList;
  }

  getMessageCss(notifierMessage: NotifierMessage) {
    const css = ['alert', 'alert-animation'];

    if (notifierMessage.type === NotifierMessageType.Success) {
      css.push('alert-success');
    } else if (notifierMessage.type === NotifierMessageType.Info) {
      css.push('alert-info');
    } else if (notifierMessage.type === NotifierMessageType.Warning) {
      css.push('alert-warning');
    } else if (notifierMessage.type === NotifierMessageType.Error) {
      css.push('alert-danger');
    } else if (notifierMessage.type === NotifierMessageType.Custom) {
      css.push('alert-custom');
    }

    return css.join(' ');
  }

  translate(translatableText: NotifierTranslatableMessage) {
    return this.translateService.instant(translatableText.key, translatableText.params);
  }

  hide(notifierMessage: NotifierMessageBase) {
    const notifierElement = jquery('#notifier-' + notifierMessage.id);
    if (notifierElement.length > 0) {
      notifierElement.fadeOut(1500, () => this.notifierService.close(notifierMessage));
    }
  };

  private setTimers() {
    const toAutoHide = this.notifierMessageList.filter((item) => item.mustAutoClose);
    for (let i = 0; i < toAutoHide.length; i++) {
      window.setTimeout(() => this.hide(toAutoHide[i]), toAutoHide[i].autoCloseTimeout);
    }
  }

  private hideAll() {
    for (let i = 0; i < this.notifierMessageList.length; i++) {
      this.hide(this.notifierMessageList[i]);
    }
  };

  private hideErrors() {
    const toHide = this.notifierMessageList.filter((item) => item.type === NotifierMessageType.Error);
    for (let i = 0; i < toHide.length; i++) {
      this.hide(toHide[i]);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/notifier/notifier.component.ts